export enum OpacityEnum {
  v_100 = 'v_100',
  v_60 = 'v_60',
  v_0 = 'v_0'
}
